import { Link } from "@tanstack/react-router";

import { cn } from "@/lib/utils";

export type PendingChangeKind = "create" | "update" | "delete" | "conflict";

type PendingChangeRowProps = {
  kind: PendingChangeKind;
  typeLabel: string;
  name: string;
  rightLabel?: string;
  /** The row opens the app's editor. */
  connectionId: string;
  appId: string;
};

const KIND_BG: Record<PendingChangeKind, string> = {
  create: "bg-status-success-bg text-status-success-foreground",
  update: "bg-brand-subtle text-brand-text",
  delete: "bg-muted text-dim",
  conflict: "bg-status-danger-bg text-status-danger-foreground",
};

const KIND_GLYPH: Record<PendingChangeKind, string> = {
  create: "+",
  update: "~",
  delete: "−",
  conflict: "!",
};

export function PendingChangeRow({
  kind,
  typeLabel,
  name,
  rightLabel,
  connectionId,
  appId,
}: PendingChangeRowProps) {
  return (
    <Link
      to="/single-app/$connectionId/apps/$appId"
      params={{ connectionId, appId }}
      className="flex w-full items-center gap-3 border-b border-hairline-soft py-2 text-left transition-colors last:border-b-0 hover:bg-muted/40"
    >
      <span
        className={cn(
          "flex h-5 w-5 shrink-0 items-center justify-center rounded-chip text-[12px] font-bold",
          KIND_BG[kind],
        )}
        aria-hidden="true"
      >
        {KIND_GLYPH[kind]}
      </span>
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <span
          className={cn(
            "shrink-0 text-[11px] font-semibold uppercase tracking-[.04em]",
            kind === "conflict" ? "text-status-danger-foreground" : "text-dim",
          )}
        >
          {typeLabel}
        </span>
        <span className="text-dim/50">·</span>
        <span className="truncate font-mono text-[12px] text-ink">{name}</span>
      </div>
      {rightLabel ? <span className="shrink-0 text-[11px] text-faint">{rightLabel}</span> : null}
    </Link>
  );
}
